import React from 'react';
import styled from 'styled-components';

interface ResetSizeButtonProps {
  onClick: (e: React.MouseEvent) => void;
  onMouseDown: (e: React.MouseEvent) => void;
  onTouchStart?: (e: React.TouchEvent) => void;
}

// リセットボタン
const StyledResetSizeButton = styled.button`
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  font-size: 14px;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  touch-action: manipulation;
  margin-right: 8px;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    color: #2196f3;
  }
  
  &:active {
    background-color: rgba(0, 0, 0, 0.1);
    color: #1976d2;
  }
`;

const ResetSizeButton: React.FC<ResetSizeButtonProps> = ({ onClick, onMouseDown, onTouchStart }) => {
  return (
    <StyledResetSizeButton 
      onClick={onClick}
      onMouseDown={onMouseDown}
      onTouchStart={onTouchStart}
      title="カードサイズをリセット"
    >
      ↺
    </StyledResetSizeButton>
  );
};

export default ResetSizeButton; 